export { default as WizardContainerTemplate } from './WizardContainerTemplate';
export { default as GeneralStepTemplate } from './GeneralStepTemplate';
export { default as DimensionsStepTemplate } from './DimensionsStepTemplate';
export { default as VirtualSKUStepTemplate } from './VirtualSKUStepTemplate';



// WEBPACK FOOTER //
// ./src/themes/default/modules/product/wizard/pages/index.js